module.exports = __webpack_public_path__ + "img/christian-aid-logo.daa89c45.svg";